/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import PasscodeInput from "../../../PasscodeInput";
import StyledButton from "../../../StyledButton";
import { SignupFormSection } from "../../Form";
import {
  PasscodeButtonsWrapper,
  PasscodeContainer,
  PasscodeProps,
  PasscodeWrapper,
} from "../ThirdForm";

export default function ChoosePasscode({
  setSelectedForm,
  form,
  handleChangeForm,
}: PasscodeProps) {
  const [error, setError] = useState<string>("");
  const [passcode, setPasscode] = useState(["", "", "", ""]);

  return (
    <PasscodeContainer>
      <PasscodeWrapper>
        <PasscodeInput
          passcode={passcode}
          handleChangePasscode={(newPassCode) => setPasscode(newPassCode)}
          error={error !== ""}
          handleChangeError={(newError) => setError(newError)}
        />
      </PasscodeWrapper>

      <PasscodeButtonsWrapper>
        <StyledButton
          onClick={() => setSelectedForm(SignupFormSection.TemporyPasscode)}
          inverted
        >
          Back
        </StyledButton>
        <StyledButton
          disable={passcode.includes("")}
          onClick={() => {
            if (passcode.includes("")) return;
            handleChangeForm("choosePasscode", passcode);
            setSelectedForm(SignupFormSection.ConfirmPasscode);
          }}
        >
          Next
        </StyledButton>
      </PasscodeButtonsWrapper>
    </PasscodeContainer>
  );
}
